var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-distributors-top"},[_c('p',{staticClass:"rating-distributors-top__last-update"},[_vm._v(" Последнее обновление: "+_vm._s(_vm.formattedDate)+" ")]),_c('p',{staticClass:"rating-distributors-top__info"},[_vm._v(" Рейтинг обновляется каждые 3 часа ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }